export enum LanguageCodes {
  ENGLISH = 'en',
  SPANISH = 'es',
  ENGLISH_EXTENDED = 'en-US',
  SPANISH_EXTENDED = 'es-US',
}
